module.exports = __webpack_public_path__ + "static/media/title3.b0f14029.jpg";